import { Box, Switch, Typography } from '@material-ui/core';
import React from 'react';
import { useCampfireLazyQuery } from '../../../../../global/network/useCampfireLazyQuery';
import { useSnackbar } from '../../../../../global/config/useSnackbar';
import { useCampfireFetch } from '../../../../../global/network/useCampfireFetch';
import { useApiUrl } from '../../../../../global/config/useApiUrl';
import { GET_SHOW_CAPACITY_STATUS } from './show-capacity-status.gql';

export function ShowCapacityStatus() {
  const [queryShowCapacityStatus] = useCampfireLazyQuery<any, {}>(GET_SHOW_CAPACITY_STATUS);
  const [enabled, setEnabled] = React.useState<boolean | undefined>();
  const { setSnackbar } = useSnackbar();

  React.useEffect(() => {
    queryShowCapacityStatus({}).then((response) =>
      setEnabled(response.data?.vm.configItem?.defaultValue || response.data?.vm.configItem?.configItemValue?.flagValue)
    );
  }, []);

  const saveFetch = useCampfireFetch({ defer: true });
  const apiUrl = useApiUrl();

  const onSave = () => {
    saveFetch
      .run({
        url: `${apiUrl}/vm/admin-console/operations/config-item`,
        method: 'post',
        data: {
          key: 'show-capacity-status',
          value: !enabled,
        },
      })
      .then(() => {
        setSnackbar({
          open: true,
          message: 'Successfully updated',
          variant: 'success',
        });
      });
    setEnabled(!enabled);
  };

  return (
    <Box mt={2}>
      <Box display='flex' alignItems={'center'}>
        <Switch
          checked={Boolean(enabled)}
          onChange={onSave}
          color='primary'
          inputProps={{ 'aria-label': 'capacity status indicators toggle' }}
        />
        <Box ml={1}>
          <Typography
            style={{
              fontWeight: 500,
              fontSize: '14px',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            Availability Capacity Indicators
          </Typography>
          <Typography variant={'body2'} style={{ fontSize: '13px', color: '#808080' }}>
            Show capacity status indicators (e.g. Spots Open, Almost Full, Full) on volunteer activity views when they
            have not yet indicated availability. Capacity counts rostered and primary held sessions only, backup
            availability doesn&apos;t count. When applicants pick sessions, full ones are hidden, or offered as backup
            only if Allow Backup Sessions is on.
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}
